<template>
  <div class="container-fluid">
    <div class="table-responsive">
      <table class="table table-bordered text-center">
        <thead class="thead-light">
          <tr>
            <th></th>
            <th v-for="h in visibleHours" :key="'h-' + h">{{ h }}h</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(day, dayIndex) in days" :key="dayIndex">
            <th class="align-middle">{{ day }}</th>
            <td
              v-for="h in visibleHours"
              :key="'c-' + dayIndex + '-' + h"
              :style="{ backgroundColor: getRedIntensity(getValue(dayIndex, h)) }"
              class="cell-square"
            >
              <span class="text-dark font-weight-bold">
                {{ getValue(dayIndex, h) || "" }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- <div class="bg-secondary text-white text-center py-2 rounded-pill mb-3">
      Total
    </div> -->

    <!-- <div class="text-center mb-2">
      <button
        v-for="category in categories"
        :key="category"
        class="btn btn-outline-secondary m-1"
        @click="activeCategory = category"
        :class="{ active: activeCategory === category }"
      >
        {{ category }}
      </button>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "CallsPerDays",
  props: {
    data: {
      type: Array,
      required: true,
    },
    /** Primera hora visible en el gráfico (0–23), inclusive (p. ej. 9 = 9:00) */
    visibleHoursFrom: {
      type: Number,
      default: 6,
    },
    /** Última hora visible en el gráfico (0–23), inclusive (p. ej. 20 = 20:00) */
    visibleHoursTo: {
      type: Number,
      default: 20,
    },
  },
  computed: {
      days() {
          return [
          this.$t("lang.label.monday"),
          this.$t("lang.label.tuesday"),
          this.$t("lang.label.wednesday"),
          this.$t("lang.label.thursday"),
          this.$t("lang.label.friday"),
          this.$t("lang.label.saturday"),
          this.$t("lang.label.sunday"),
          ];
      },
      /**
       * Horas visibles: rango [visibleHoursFrom … visibleHoursTo] en orden 0→23.
       * Fuera de ese rango no se muestran columnas (datos de esas horas quedan fuera del gráfico).
       */
      visibleHours() {
        let from = Math.max(0, Math.min(23, this.visibleHoursFrom));
        let to = Math.max(0, Math.min(23, this.visibleHoursTo));
        if (from > to) {
          const t = from;
          from = to;
          to = t;
        }
        const hours = [];
        for (let h = from; h <= to; h++) {
          hours.push(h);
        }
        return hours;
      },
  },
  data() {
    return {
      categories: [
        "Positif",
        "Neutre",
        "Pas De Réponse",
        "Secrétariat",
        "Mauvais Numéro",
        "Contact Hors Cible",
        "Entreprise Hors Cible",
        "Négatif",
      ],
      activeCategory: "Positif",
    };
  },
  methods: {
    getValue(dayIndex, hour) {
      const cell = this.data.find(
        (item) =>
          item.dayIndex === dayIndex &&
          item.hour === hour &&
          item.category === this.activeCategory
      );
      return cell ? cell.value : 0;
    },
    getRedIntensity(value) {

      if (!value || value <= 0) return 'rgb(255, 230, 230)'

      const maxValue = 100
      const factor = Math.min(value, maxValue) / maxValue

      const greenBlue = Math.floor(230 - (factor * 180))

      return `rgb(255, ${greenBlue}, ${greenBlue})`
     }

  },
};
</script>

<style scoped>
.cell-square {
  width: 35px;
  height: 35px;
  padding: 0;
}
.btn.active {
  font-weight: bold;
}
</style>
